import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import Webform from '../../../components/Webform';

import WebformSelect from '../../../components/WebformSelect';

import './style.scss';

const ParagraphWebform = ({ entity }) => {
  const id = entity.getIn(['field_webform', 0, 'target_id']);

  return (
    <Container className="ParagraphWebform">
      <div className="row">
        <div className="ParagraphWebform__inner col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <Webform
            root
            id={id}
            overriddenComponents={{ select: WebformSelect }}
          />
        </div>
      </div>
    </Container>
  );
};

export default ParagraphWebform;
